import Translations from "translations/types";

const REHAB_FORM_TOUR_STEPS = {
  ELIGIBILITY_TAB: "eligibility_tab",
  FILL_IN_GKV_GENERAL_FORM: "fill_in_gkv_general_form",
  FILL_IN_GKV_MEDICAL_FORM: "fill_in_gkv_medical_form",
  REPLY_SECTION: "reply_section",
  SEND_DOCUMENTS_BUTTON: "send_documents_button",
  SEND_DOCUMENTS_HEADING: "send_documents_heading",
} as const;

export const REHAB_FORMS_TOUR = {
  disablePageScroll: true,
  doneLabel: (t: Translations) => t.tours.reverseSearch.doneButton,
  exitOnOverlayClick: false,
  key: "dta",
  nextLabel: (t: Translations) => t.tours.reverseSearch.nextButton,
  prevLabel: (t: Translations) => t.tours.reverseSearch.backButton,
  steps: {
    [REHAB_FORM_TOUR_STEPS.FILL_IN_GKV_GENERAL_FORM]: {
      intro: (t: Translations) => t.tours.dta.stepC.intro,
      key: REHAB_FORM_TOUR_STEPS.FILL_IN_GKV_GENERAL_FORM,
      step: 2,
      title: (t: Translations) => t.tours.dta.stepC.title,
    },
    [REHAB_FORM_TOUR_STEPS.FILL_IN_GKV_MEDICAL_FORM]: {
      intro: (t: Translations) => t.tours.dta.stepD.intro,
      key: REHAB_FORM_TOUR_STEPS.FILL_IN_GKV_MEDICAL_FORM,
      step: 3,
      title: (t: Translations) => t.tours.dta.stepD.title,
    },
    [REHAB_FORM_TOUR_STEPS.REPLY_SECTION]: {
      intro: (t: Translations) => t.tours.dta.stepF.intro,
      key: REHAB_FORM_TOUR_STEPS.REPLY_SECTION,
      step: 5,
      title: (t: Translations) => t.tours.dta.stepF.title,
    },
    [REHAB_FORM_TOUR_STEPS.SEND_DOCUMENTS_BUTTON]: {
      intro: (t: Translations) => t.tours.dta.stepE.intro,
      key: REHAB_FORM_TOUR_STEPS.SEND_DOCUMENTS_BUTTON,
      step: 4,
      title: (t: Translations) => t.tours.dta.stepE.title,
    },
    [REHAB_FORM_TOUR_STEPS.SEND_DOCUMENTS_HEADING]: {
      intro: (t: Translations) => t.tours.dta.stepB.intro,
      key: REHAB_FORM_TOUR_STEPS.SEND_DOCUMENTS_HEADING,
      step: 1,
      title: (t: Translations) => t.tours.dta.stepB.title,
    },
  },
} as const;
